import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
export const NumericStepper = ({ value, onChange, max, min }) => {
    const onPlus = () => {
        if (!value) {
            onChange(1);
            return;
        }
        onChange(Math.min(max, value + 1));
    };
    const onMinus = () => {
        if (!value) {
            onChange(1);
            return;
        }
        onChange(Math.max(min, value - 1));
    };
    return (<div className="flex items-center gap-3">
			<button type="button" onClick={onMinus} className="p-1 bg-slate-700 rounded hover:bg-slate-600 disabled:brightness-75 disabled:hover:bg-slate-700" disabled={value ? value <= min : true}>
				<RemoveIcon fontSize="medium"/>
			</button>
			<span className="w-8 text-center font-bold select-none">
				{value || '-'}
			</span>
			<button type="button" onClick={onPlus} disabled={value ? value >= max : false} className="p-1 bg-slate-700 rounded hover:bg-slate-600 disabled:brightness-75 disabled:hover:bg-slate-700">
				<AddIcon fontSize="medium"/>
			</button>
		</div>);
};
